<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a @click="backButton"><li>Investment</li></a>
      <a @click="depositeDashbord"><li>&nbsp;>&nbsp;Deposit Details</li></a>
      <a @click="depositeAccounts"><li>&nbsp;>&nbsp;Deposit Accounts</li></a>

      <li>&nbsp;>&nbsp;Saving Accounts</li>
    </ul>
    <h4 class="welcome-text">Saving Accounts</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"
          v-model="valid"
          lazy-validation
          @submit.prevent
          class="login-form-box register-page"
        >
          <h4>Enter Details</h4>

          <v-row>
            <v-col
              xs="12"
              md="6"
              class="member_relation_box col"
              v-for="formAttr in formAttributes"
              :key="formAttr.id"
            >
              <label
                class="member-label"
                v-if="formAttr['name'] == 'account_balance'"
                >{{ formAttr["label"] }}
                <a
                  href="javascript:void(0)"
                  v-on:click="getAccountHelpDetail()"
                  title="Get account help"
                  >Get Help</a
                ></label
              >
              <label class="member-label" v-else>{{ formAttr["label"] }}</label>
              <!--  <input type="text" :name="formAttr['name']"> -->
              <div
                v-if="
                  formAttr['type'] == 'select' && formAttr['name'] != 'nominee'
                "
              >
                <v-select
                  ref="form_attrs"
                  :name="formAttr['name']"
                  :v-model="formAttr['name']"
                  :items="
                    formAttr['name'] == 'account_type'
                      ? accountType
                      : formAttr['name'] == 'bank_name'
                      ? bank
                      : formAttr['name'] == 'account_owner'
                      ? account_owner
                      : formAttr['name'] == 'joint_account_owner'
                      ? joint_account_owner
                      : formAttr['name'] == 'nominee'
                      ? nominee
                      : familyMember
                  "
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                ></v-select>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'select' && formAttr['name'] =='nominee'
                "
              >
                <v-combobox
                  :ref="formAttr['name']"
                  :name="formAttr['name']"
                  v-model="addMoreField"
                  :items="nominee"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                  multiple
                  small-chips
                  solo
                  v-on:input="limiter"
                  deletable-chips
                ></v-combobox>
                <a @click="appendField" class="add-newbox">Add New Nominee</a>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] != 'account_balance' &&
                  formAttr['name'] != 'account_no'
                "
              >
                <v-text-field
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :rules="
                    formAttr['is_required'] == true
                      ? [
                          (v) => !!v || 'Field is required',
                          (v) =>
                            /^(0|[1-9]\d*)$/.test(v) || 'Field must be numeric',
                        ]
                      : []
                  "
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  @input="changeTextFieldEvent"
                ></v-text-field>
              </div>

              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] == 'account_no'
                "
              >
                <v-text-field
                  :name="formAttr['name']"
                  :maxlength="max_acc_length"
                  ref="form_attrs"
                  :rules="
                    formAttr['is_required'] == false
                      ? [
                          (v) =>
                            !v ||
                            /^(?=.*[0-9])[a-zA-Z0-9]+$/.test(v) ||
                            'Field must be alphanumeric or numeric',
                        ]
                      : []
                  "
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  @input="changeTextFieldEvent"
                ></v-text-field>
              </div>

              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] == 'account_balance'
                "
                class="rupee-icon"
              >
                <v-text-field
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :rules="
                    formAttr['is_required'] == true
                      ? [
                          (v) => !!v || 'Field is required',
                          (v) =>
                            /^\d{0,8}[.]?\d{1,2}$/ .test(v) || 'Field must be numeric',
                        ]
                      : []
                  "
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  @input="changeTextFieldEvent"
                ></v-text-field>
              </div>

              <div v-else-if="formAttr['type'] == 'date'" class="dob-box">
                <Datepicker
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :v-model="formAttr['name']"
                  format="dd MMM, yyyy"
                  :disabledDates="disabledDates"
                ></Datepicker>
              </div>
            </v-col>
          </v-row>
          <span
            v-bind:class="{ 'error-messagebox-login': isAddClassServerError }"
            id="server_side_error"
            >{{ serverError }}</span
          >
          <v-row class="buttonbox">
            <v-btn class="blue-border-btn" @click="depositeAccounts">
              Cancel
            </v-btn>
            <v-btn class="blue-btn" @click="submit" :disabled="!isFormValid">
              Save
            </v-btn>
          </v-row>
        </v-form>
      </div>
    </div>
    <v-dialog v-model="account_help_dialog" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          How to know your Account Balance
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col> </v-col>
          </v-row>
          <div class="custom-notiBox">
            <v-layout class="notificationbox">
              <div class="noti-box inner-notificationbox">
                <v-card class="imagebox">
                  <div
                    class="noti-innerBox"
                    v-if="this.missed_call_no_array != ''"
                  >
                    <h4 style="padding-top: 10px !important">
                      Give missed call to
                      {{ this.missed_call_no_array.missed_call_no }} from your
                      registered mobile no.
                    </h4>
                    <v-img
                      max-height="25"
                      max-width="25"
                      :src="phone_icon"
                      :lazy-src="phone_icon"
                    ></v-img>
                  </div>

                  <div class="noti-innerBox" v-if="this.sms_array != ''">
                    <h4 style="padding-top: 10px !important">
                      Send SMS ({{ this.sms_array.sms_str }}) to
                      {{ this.sms_array.sms_no }}
                    </h4>
                    <v-img
                      max-height="25"
                      max-width="25"
                      :src="sms_icon"
                      :lazy-src="sms_icon"
                    ></v-img>
                  </div>

                  <div
                    class="noti-innerBox"
                    v-if="this.whatsapp_no_array != ''"
                  >
                    <h4 style="padding-top: 10px !important">
                      Say ({{ whatsapp_no_array.sms_str }} ) to
                      {{ whatsapp_no_array.sms_no }}
                    </h4>
                    <v-img
                      max-height="25"
                      max-width="25"
                      :src="whatsapp_icon"
                      :lazy-src="whatsapp_icon"
                      style="margin-top: 6px !important"
                    ></v-img>
                  </div>
                </v-card>
              </div>
            </v-layout>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="account_help_dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  sameAs,
  isAlphanumeric,
  alpha,
  numeric,
  maxLength,
} from "vuelidate/lib/validators";
import { Auth } from "aws-amplify";
import {
  GET_SAVING_ACCOUNT_FORM_DATA,
  SAVE_DEPOSIT_DATA,
  GET_DEPOSIT_DATA,
} from "../../store/actions.type";
import { isEmpty } from "lodash";
import axios from "axios";

export default {
  components: {
    Datepicker,
  },
  mixins: [validationMixin],
  validations: {},
  data: () => ({
    valid: true,
    submitted: false,
    activePicker: null,
    menu: false,
    disabledDates: {
      from: new Date(),
    },
    serverError: "",
    isAddClassServerError: false,
    formAttributes: "",
    formAttr: "",
    other_form_field: [],
    accountType: [],
    bank: [],
    familyMember: [],
    nominee: [],
    other_nominee: [],
    curr_balance_date: "",
    account_type: "",
    bank_name: "",
    max_acc_length: 20,
    account_owne: "",
    addMoreField: [],
    nomineeMembers: [],
    form_id: "",
    account_owner: [],
    joint_account_owner: [],
    nominee: [],
    removeFieldData: false,
    allow_nominee: 1,
    checkFormData: [],
    isFormValid: false,
    account_help_dialog: false,
    sms_icon: process.env.VUE_APP_ROOT_ICONS_URL + "sms_icon.png",
    whatsapp_icon: process.env.VUE_APP_ROOT_ICONS_URL + "whatsapp_icon.png",
    phone_icon: process.env.VUE_APP_ROOT_ICONS_URL + "phone_icon.png",
    getFormData: "",
    account_help_array: [],
    missed_call_no_array: "",
    sms_array: "",
    whatsapp_no_array: "",
  }),

  created() {
    Fire.$on("loadData", () => {
      this.getSavingFormData();
    });
  },
  mounted() {
    if (isEmpty(this.$store.getters.getSavingAccountFormData)) {
      this.getSavingFormData();
    } else {
      this.allow_nominee =
        this.$store.getters.getSavingAccountFormData.allow_nominee;
      this.form_id = this.$store.getters.getSavingAccountFormData.data.form_id;
      this.formAttributes =
        this.$store.getters.getSavingAccountFormData.data.form_attributes.fields;
      let masterDataArr =
        this.$store.getters.getSavingAccountFormData.data.master_data;
      masterDataArr.forEach((element) => {
        if (element.AccountType) {
          element.AccountType.forEach((dataAccountType) => {
            this.accountType.push({
              id: dataAccountType.id,
              name: dataAccountType.name,
            });
          });
        }
        if (element.FamilyMember) {
          element.FamilyMember.forEach((dataFamily) => {
            this.nominee.push(dataFamily.name);
            if (dataFamily.id == 0) {
              this.account_owner.push({ id: "0", name: dataFamily.name });
            } else {
              this.account_owner.push({
                id: dataFamily.id,
                name: dataFamily.name,
              });
            }
            this.joint_account_owner.push({
              id: dataFamily.id,
              name: dataFamily.name,
            });
          });
        }
      });
    }
  },
  methods: {
    changeTextFieldEvent() {
      this.isFormValid = this.$refs.form.validate();
    },
    limiter(e) {
      if (e.length + this.other_form_field.length > 3) {
        swal
          .fire({
            title: "Nominee",
            text: "You can add maximum 3 nominees.",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#051d42",
            //cancelButtonColor: '#d33',
            confirmButtonText: "OK",
            //cancelButtonText:'No'
          })
          .then((result) => {
            if (result.isConfirmed) {
              e.pop();
              return;
            }
          });
      }
    },
    validate() {
      this.$refs.form.validate();
    },
    backButton() {
      this.checkFormData = [];
      let getFormData = document.querySelector("#saving_account");
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      this.checkFormData.length > 0
        ? swal
            .fire({
              title:
                "Your data will be cleared. Are you sure you want to close this?",
              showCancelButton: true,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `YES`,
              cancelButtonColor: `#f19700`,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router.push({ name: "Investment" }).catch(() => {});
              }
            })
        : this.$router.push({ name: "Investment" }).catch(() => {});
    },
    depositeAccounts() {
      this.checkFormData = [];
      let getFormData = document.querySelector("#saving_account");
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      this.checkFormData.length > 0
        ? swal
            .fire({
              title:
                "Your data will be cleared. Are you sure you want to close this?",
              showCancelButton: true,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `YES`,
              cancelButtonColor: `#f19700`,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router.push({ name: "SubCategory" }).catch(() => {});
              }
            })
        : this.$router.push({ name: "SubCategory" }).catch(() => {});
      //this.$router.push({ name: 'SubCategory'});
    },
    appendField() {
      swal
        .fire({
          input: "text",
          inputPlaceholder: "Enter Nominee",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: `Save`,
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then((result) => {
          if (result.value) {
            let letters = /^[A-Za-z]+$/;
           if(result.value.length > 30){
                 swal.fire({
                  title: 'Nominee',
                  text: "Nominee Name may not be greater than 30 character.",
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#051d42',
                  confirmButtonText: 'OK',
                  }).then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                })
              } 
           else if (result.value.match(letters)) {
              this.nominee.push(result.value);
              this.addMoreField.push(result.value);
            }else {
              swal
                .fire({
                  title: "Nominee",
                  text: "Please enter valid name.",
                  icon: "warning",
                  showCancelButton: false,
                  confirmButtonColor: "#051d42",
                  confirmButtonText: "OK",
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                });
            }
          }
          if (result.value == "") {
            swal
              .fire({
                title: "Nominee",
                text: "This field is required.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#051d42",
                confirmButtonText: "OK",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  e.pop();
                  return;
                }
              });
          }
        });
      if (this.addMoreField.length >= 3) {
        swal
          .fire({
            title: "Nominee",
            text: "You can add maximum 3 nominees.",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#051d42",
            //cancelButtonColor: '#d33',
            confirmButtonText: "OK",
            //cancelButtonText:'No'
          })
          .then((result) => {
            if (result.isConfirmed) {
              e.pop();
              return;
            }
          });
      }
    },
    removeField(lineId) {
      this.other_form_field.splice(lineId, 1);
    },
    setData(key) {},
    submit(e) {
      let getFormData = document.querySelector("#saving_account");
      this.checkFormData = [];
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      if (this.checkFormData.length > 0) {
        this.submitted = true;
        this.$loading(true);
        // var vm = this
        // var formData = new FormData(getFormData)
        let jsonObject = [];
        let nominee = [];
        let i = 0;
        for (const [key, value] of formData.entries()) {
          if (key == "nominee" && value != "") {
            value.split(",").forEach((nomineeData) => {
              nominee.push(nomineeData);
            });
          } else if (Number.isInteger(parseInt(key)) == true) {
            nominee.push(value);
          } else if (
            key == "account_type" ||
            key == "bank_name" ||
            key == "account_owner"
          ) {
            jsonObject.push({ key: key, values: parseInt(value) });
          } else {
            if (key != "nominee") {
              jsonObject.push({ key: key, values: value });
            }
          }
          i++;
        }
        let nomineeArr = { key: "nominee", values: nominee };
        jsonObject.push(nomineeArr);

        let collected_data = { collected_data: jsonObject };
        this.$store
          .dispatch(SAVE_DEPOSIT_DATA, {
            data: {
              aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
              form_id: this.form_id,
              account_owner: getFormData.account_owner.value,
              form_detail: JSON.stringify(collected_data),
            },
            api: "save-user-form-detail",
          })
          .then(() => {
            this.savingAccountList();

            this.$loading(false);
            Toast.fire({
              icon: "success",
              title: "Saving account form saved successfully",
            });
          })
          .catch(() => {
            this.$loading(false);
          });

        this.$router
          .push({ name: "deposit-dashboard", params: { tab: "tab-1" } })
          .catch(() => {});
      } else {
        return;
      }
    },
    setMasterData: function (attr_type, val) {
      this.isFormValid = this.$refs.form.validate();
      if (attr_type == "account_type") {
        this.bank = [];

        this.$store.getters.getBankPoMasterData.forEach((attrData) => {
          if (attrData["id"] == val) {
            attrData["list"].forEach((databank) => {
              this.bank.push({ id: databank.id, name: databank.name });

            });
          }
        });
      } else if (attr_type == "account_owner") {
        let masterDataArr =
          this.$store.getters.getSavingAccountFormData.data.master_data;
        let i = 0;
        this.nominee = [];
        this.joint_account_owner = [];
        this.addMoreField = [];
        masterDataArr["2"]["FamilyMember"].forEach((familyMember) => {
          if (parseInt(val) != parseInt(familyMember["id"])) {
            //if (familyMember.id != '') {
            this.nominee.push(familyMember.name);
            //}
            this.joint_account_owner.push({
              id: familyMember.id,
              name: familyMember.name,
            });
          }
          i++;
        });
      }
    },
    appendFieldOnNominee(attr_type, val) {
      if (this.removeFieldData) {
        this.removeField(attr_type, 1);
      } else {
        this.nominee.push(val);
        this.addMoreField.push(val);
        this.other_form_field.splice(attr_type, 1);
      }
    },
    depositeDashbord() {
      this.checkFormData = [];
      let getFormData = document.querySelector("#saving_account");
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      this.checkFormData.length > 0
        ? swal
            .fire({
              title: "Your data will be lost are you sure you want to go back?",
              showCancelButton: true,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `YES`,
              cancelButtonColor: `#f19700`,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router
                  .push({ name: "deposit-dashboard" })
                  .catch(() => {});
              }
            })
        : this.$router.push({ name: "deposit-dashboard" }).catch(() => {});
    },
    showMore() {
      return (this.removeFieldData = true);
    },
    savingAccountList() {
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let user_name = this.$store.getters.getUserDetails.user_name;
      let selected_value = this.$store.getters.getUserDetails.selected_value;
      this.$loading(true);
      this.$store
        .dispatch(GET_DEPOSIT_DATA, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            member_id: selected_value,
          },
          api: "get-user-form-detail",
        })
        .then(() => {
          this.amount = 0;
          this.savingAccountData =
            this.$store.getters.allDepositData.data.saving_account_detail;
          Fire.$emit("updateAllDepositData");
          Fire.$emit("updateSavingAccountData");
          this.savingAccountData.forEach((details) => {
            details.description.forEach((total) => {
              this.amount += parseFloat(total.account_balance);
            });
          });
          this.amount = this.amount.toFixed(2);
          this.$loading(false);
        })
        .catch(() => {
          this.$loading(false);
        });
    },

    getSavingFormData() {
      if (this.$store.getters.getUserDetails.user_name != undefined) {
        let cognito_idp = atob(localStorage.getItem("cognito_idp"));
        let user_name = this.$store.getters.getUserDetails.user_name;
        this.$loading(true);
        this.$store
          .dispatch(GET_SAVING_ACCOUNT_FORM_DATA, {
            data: {
              aws_cognito_id: cognito_idp,
              user_name: user_name,
              form_type: 1,
            },
            api: "get-form",
          })
          .then(() => {
            this.allow_nominee =
              this.$store.getters.getSavingAccountFormData.allow_nominee;
            this.form_id =
              this.$store.getters.getSavingAccountFormData.data.form_id;
            this.formAttributes =
              this.$store.getters.getSavingAccountFormData.data.form_attributes.fields;
            let masterDataArr =
              this.$store.getters.getSavingAccountFormData.data.master_data;
            masterDataArr.forEach((element) => {
              if (element.AccountType) {
                element.AccountType.forEach((dataAccountType) => {
                  this.accountType.push({
                    id: dataAccountType.id,
                    name: dataAccountType.name,
                  });
                });
              }
              if (element.FamilyMember) {
                element.FamilyMember.forEach((dataFamily) => {
                  this.nominee.push(dataFamily.name);
                  if (dataFamily.id == 0) {
                    this.account_owner.push({ id: "0", name: dataFamily.name });
                  } else {
                    this.account_owner.push({
                      id: dataFamily.id,
                      name: dataFamily.name,
                    });
                  }
                  this.joint_account_owner.push({
                    id: dataFamily.id,
                    name: dataFamily.name,
                  });
                });
              }
            });
            this.$loading(false);
          })
          .catch(() => {
            this.$loading(false);
          });
      }
    },

    getAccountHelpDetail() {
      this.getFormData = document.querySelector("#saving_account");
      if (this.getFormData.bank_name.value == "") {
        swal.fire({ title: "Please choose Bank/PO" });
      } else if (this.getFormData.account_no.value == "") {
        swal.fire({ title: "Please enter account no." });
      } else {
        let formdata = new FormData();
        formdata.append(
          "aws_cognito_id",
          atob(localStorage.getItem("cognito_idp"))
        );
        formdata.append("bank_id", this.getFormData.bank_name.value);
        formdata.append("type", this.getFormData.account_type.value);
        formdata.append("acc_no", this.getFormData.account_no.value);
        axios
          .post(
            process.env.VUE_APP_ROOT_API + "get-bank-help-detail-web-app",
            formdata
          )
          .then((res) => {
            this.missed_call_no_array = res.data.data.missed_call_no_array;
            this.sms_array = res.data.data.sms_array;
            this.whatsapp_no_array = res.data.data.whatsapp_no_array;
            setTimeout(() => {
              this.account_help_dialog = true;
            }, 500);
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.noti-box.inner-notificationbox .imagebox {
  max-width: 449px !important;
}
</style>
